import { useMemo } from 'react';

/**
 * Hook will take the singletone service instance later keeping it memoized
 * @param service
 */
export function useService<T>(service: { new (): T }): T {
    return useMemo<T>(() => (service as any).getInstance(), []);
}

/**
 * Hook will take instance of the given class memoized
 * @param Class
 * @param args
 */
export function useClass<S, A extends []>(Class: { new (...args: A): S }, ...args: A): S {
    return useMemo<S>(() => new Class(...args), []);
}
